module.exports = __webpack_public_path__ + "static/media/2_The inner voice_DE.e06e6336.txt";